app.controller("LoanCalculatorController",
	["$scope", "$timeout", "$http", "loanCalculatorService", "$window", function($scope, $timeout, $http, loanCalculatorService, $window) {
		$scope.defaultSavings = 0.10;
		$scope.monthlyDue = 0;
		$scope.loanTimeOptions = loanCalculatorService.getLoanTimeOptions();
		$scope.sending = false;
		$scope.sent = false;
		$scope.propertyId = undefined;
		$scope.property = {
			price: 0,
			time: loanCalculatorService.getLoanTime(),
			interest: loanCalculatorService.getInterestRate(),
			savings: 0,
			batches: loanCalculatorService.getLoanBatches(),
			wholeEstimate: loanCalculatorService.getWholeEstimate(),
			address: '',
			type: '',
			rooms: '',
			url: ''
		};

		$scope.form = {
			name: '',
			email: '',
			location: '',
			birthYear: '',
			phone: '',
			message: ''
		};
		$scope.openTooltips = [];

		$timeout(function() {
			var savedDetails = loanCalculatorService.getSavedDetails($scope.propertyId);
			
			if (savedDetails) {
				$scope.property.price = savedDetails.price;
				$scope.property.savings = savedDetails.savings;
				$scope.property.time = savedDetails.time;
				$scope.property.interest = savedDetails.interest;
			}

			loanCalculatorService.setDetails($scope.property.price, $scope.property.time, $scope.property.interest, $scope.property.savings);
			$scope.monthlyDue = loanCalculatorService.getMonthlyDue();
			$scope.property.batches = loanCalculatorService.getLoanBatches();
			$scope.property.wholeEstimate = loanCalculatorService.getWholeEstimate();
			$scope.property.savings = $scope.property.savings === 0 ? $scope.property.price * $scope.defaultSavings : $scope.property.savings;
		});

		$scope.$watchCollection('property', function() {
			loanCalculatorService.setDetails($scope.property.price, $scope.property.time, $scope.property.interest, $scope.property.savings);
			$scope.monthlyDue = loanCalculatorService.getMonthlyDue();
			$scope.property.batches = loanCalculatorService.getLoanBatches();
			$scope.property.wholeEstimate = loanCalculatorService.getWholeEstimate();
		});

		$scope.resetForm = function() {
			$scope.sent = false;
			$scope.errors = {};
			window.location.hash = '#';
			window.location.hash = '#loanCalculatorForm';
		};

		$scope.sendForm = function() {

			var errors = {
				personName: 'Syötä nimi',
				personLocation: 'Syötä postinumero',
				personEmail: 'Virheellinen sähköpostiosoite',
				personPhone: 'Virheellinen puhelinnumero',
				personBirthYear: 'Virheellinen syntymävuosi',
			};

			if ($scope.errors == null) {
				$scope.errors = {};
			}
			$scope.sending = true;

			var formData = {
				personName: $scope.form.name,
				personEmail: $scope.form.email,
				personPhone: $scope.form.phone,
				personBirthYear: $scope.form.birthYear,
				personLocation: $scope.form.location,
				personMessage: $scope.form.message,
				calculationPrice: $scope.property.price,
				calculationTime: $scope.property.time,
				calculationInterest: $scope.property.interest,
				calculationSavings: $scope.property.savings,
				calculationBatches: $scope.property.batches,
				calculationWholeEstimate: $scope.property.wholeEstimate,
				calculationMonthlyDue: $scope.monthlyDue,
				propertyAddress: $scope.property.address,
				propertyType: $scope.property.type,
				propertyRooms: $scope.property.rooms,
				propertyPrice: $scope.property.price,
				propertyUrl: $scope.property.url,
				formID: 'loanCalculationForm',
				subject: 'Lainatarjouspyyntö'
			};
			if ($window.wakeTestEmail !== undefined) {
				formData.wakeTestEmail = $window.wakeTestEmail;
			}

			$http({
                method: "POST",
                url: "/api/km/KMSite/processForm",
                data: formData
            })
            .then(function(response) {
				$scope.sending = false;
				$scope.sent = true;
				_gaq.push(['_trackEvent', 'Pyydä lainatarjous', 'Lähetä']);				
				window.location.hash = '#';
				window.location.hash = '#loanCalculatorForm';
			},
				function(results) {
					$scope.sending = false;
					for (var key in results.data.data) {
						if (!results.data.data[key].success) {
							$scope.errors[key] = errors[key];
						} else {
							$scope.errors[key] = null;
						}
					}
				});
		};

		$scope.showTooltip = function(elem) {
			var tooltip = angular.element(elem);

			if (tooltip.hasClass('visible')) {
				$scope.removeTooltip(elem);
			}
			else {
				tooltip.addClass('visible');

				for (var i in $scope.openTooltips) {
					$scope.removeTooltip(i);
				}

				$scope.openTooltips[elem] = true;
			}
		};

		$scope.removeTooltip = function(elem) {
			angular.element(elem).removeClass('visible');
			delete $scope.openTooltips[elem];
		};
	}]
);